module.exports = __webpack_public_path__ + "static/media/banksxtelcos.9ef21269.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banksxtelcos.svg
// module id = 306
// module chunks = 25